import apiClient from '../lib/apiClient';

const offerLettersService = {
  // Get all offer letters
  getOfferLetters: async (filters = {}) => {
    try {
      const result = await apiClient.get('/offer-letters', filters);
      return result;
    } catch (error) {
      // Safely extract error message
      let errorMessage = 'Failed to fetch offer letters';
      if (error && typeof error === 'object') {
        errorMessage = error.message || error.error || String(error);
      } else if (error) {
        errorMessage = String(error);
      }
      return { success: false, error: errorMessage };
    }
  },

  // Get accepted offer letters
  getAcceptedOfferLetters: async () => {
    try {
      // Pass status=accepted as filter
      const result = await apiClient.get('/offer-letters', { status: 'accepted' });
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch accepted offer letters' };
    }
  },

  // Get offer letter by ID
  getOfferLetter: async (id) => {
    try {
      const result = await apiClient.get(`/offer-letters/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch offer letter' };
    }
  },

  // Create offer letter
  createOfferLetter: async (data) => {
    try {
      const result = await apiClient.post('/offer-letters', data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create offer letter' };
    }
  },

  // Update offer letter
  updateOfferLetter: async (id, data) => {
    try {
      const result = await apiClient.put(`/offer-letters/${id}`, data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update offer letter' };
    }
  },

  // Delete offer letter
  deleteOfferLetter: async (id) => {
    try {
      const result = await apiClient.delete(`/offer-letters/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete offer letter' };
    }
  },

  // Download offer letter as PDF
  downloadOfferLetter: async (id, recipientName = '') => {
    try {
      const token = apiClient.getToken();
      const baseURL = apiClient.baseURL;
      const response = await fetch(`${baseURL}/offer-letters/${id}/download`, {
        method: 'GET',
        headers: {
          ...(token && { Authorization: `Bearer ${token}` }),
        },
      });

      if (!response.ok) {
        let errorMessage = 'Failed to download offer letter';
        try {
          const errorData = await response.json();
          errorMessage = errorData.error || errorData.message || errorMessage;
        } catch {
          // response may be non-JSON
        }
        return { success: false, error: errorMessage };
      }

      const blob = await response.blob();
      const disposition = response.headers.get('Content-Disposition') || '';
      const match = disposition.match(/filename="?([^"]+)"?/i);
      const safeName = (recipientName || 'Offer_Letter').replace(/[^A-Za-z0-9_\-]/g, '_');
      const filename = match?.[1] || `Offer_Letter_${safeName}.pdf`;

      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(downloadUrl);

      return { success: true };
    } catch (error) {
      return { success: false, error: error.message || 'Failed to download offer letter' };
    }
  }
};

export default offerLettersService;